
import {
    call, put, select, fork
} from 'redux-saga/effects';
import desking from '../../libs/showroom';
import { Creators as actions } from '../actions';
import {
    getConfig,
    getQuote,
    getPaymentOptions,
    getQuoteId,
    getShowroomQueryParams
} from '../selectors';
import refreshQuote from './refreshQuote';
import { transformFinanceOptionsRequest } from './api/helpers';

/**
 * @param {Object} params
 */
function* updateQuoteInformation() {
    const quoteId = yield select(getQuoteId);
    const { showroomApiUrl, token } = yield select(getConfig);
    const showroomQueryParams = yield select(getShowroomQueryParams);

    const quote = yield select(getQuote);
    const paymentOptions = yield select(getPaymentOptions);
    const body = {
        id: quoteId,
        leadId: quote.leadId,
        accountId: quote.accountId,
        quoteRevision: quote.quoteRevision,
        transactionToken: paymentOptions.transactionToken,
        saleType: paymentOptions.saleType,
        taxPlan: paymentOptions.taxPlan,
        vehicleCondition: paymentOptions.vehicleCondition,
        purchaseMethod: paymentOptions.purchaseMethod,
        financePlan: paymentOptions.financePlan,
        kmPerYearPlan: paymentOptions.kmPerYearPlan,
        paymentFrequency: paymentOptions.paymentFrequency,
        term: paymentOptions.term,
        cashDown: paymentOptions.cashDown,
        tradeIn: paymentOptions.tradeIn,
        lien: paymentOptions.lien,
        financeOptions: transformFinanceOptionsRequest(paymentOptions.financeOptions)
    };

    try {
        yield call(desking.updateQuoteInformation, showroomApiUrl, token, quoteId, showroomQueryParams, body);
        yield call(refreshQuote);
    } catch (error) {
        yield put(actions.handleError(error));
    }
}

export default updateQuoteInformation;
